/**
 * Route for `custom-fx-rate-per-invoice`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CustomFxRatePerInvoicePage } from "../features/custom-fx-rate-per-invoice/CustomFxRatePerInvoicePage";

export const customFxRatePerInvoiceRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/custom-fx-rate-per-invoice",
	component: CustomFxRatePerInvoicePage,
});

export default customFxRatePerInvoiceRoute;
